import { deleteRequest, getRequest, postRequest } from '../util/api';
import { getConfigObject } from '../util/config';

const VERSION1 = '/api/v1/dashboards';

export const getCoursePreferencesView = async () => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await getRequest(
    `${DASHBOARD_API_URL}${VERSION1}/views/course-preferences`
  );
};

export const getCoursePreference = (preference) => async (courseId) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  const preferenceUrl = `${DASHBOARD_API_URL}/api/v1/dashboards/courses/${courseId}/preferences/${preference}`;
  try {
    const { enabled } = await getRequest(preferenceUrl);
    return enabled;
  } catch {
    return false;
  }
};

export const saveCoursePreference = async (
  courseId,
  preferenceName,
  enabled = true
) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await postRequest(
    `${DASHBOARD_API_URL}${VERSION1}/courses/${courseId}/preferences/${preferenceName}`,
    {
      enabled,
    }
  );
};

export const saveCoursePreferenceBulk = async (
  coursePreferences,
  enabled = true
) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await postRequest(
    `${DASHBOARD_API_URL}${VERSION1}/course-preferences`,
    {
      coursePreferences,
      enabled,
    }
  );
};

export const removeCoursePreferenceBulk = async (coursePreferences) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await deleteRequest(
    `${DASHBOARD_API_URL}${VERSION1}/course-preferences`,
    {
      coursePreferences,
    }
  );
};

export const getCoursePreferenceStatusBulk = async (preferenceName) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await getRequest(
    `${DASHBOARD_API_URL}${VERSION1}/course-preferences?preference=${preferenceName}`
  );
};

export const getGrsAiSummariesPreference = getCoursePreference(
  'grs_ai_summaries'
);

/**
 * Fetch ml-authz AI feature access, e.g. `{ content_generation: true }`.
 * On error returns `{}` (fail open).
 */
export const getAiFeatureAccess = async (courseId) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  const url = `${DASHBOARD_API_URL}${VERSION1}/courses/${courseId}/ai-feature-access`;
  try {
    return await getRequest(url);
  } catch {
    // Fail open — if the check fails, assume all features are allowed
    return {};
  }
};
